import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import { paymentinstrumentreport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { accountsLocations, getMultipleSubAccountLocations } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';

export const ibftColumns = [
  { label: "Payment ID", key: "PaymentID" },
  { label: "Paid On", key: "PaidOn" },
  { label: "RR Amount", key: "RRAmount" },
  { label: "Invoice Amount", key: "InvoiceAmount" },
  { label: "IBFT Fee", key: "IBFTFee" },
  { label: "Tax Amount", key: "TaxAmount" },
  { label: "Net Payable", key: "NetPayable" },
  { label: "Instrument Mode", key: "InstrumentMode" },
  { label: "Instrument Number", key: "InstrumentNumber" },
];


const PaymentInstrumentReport = () => {
    const dispatch = useDispatch();
    const { accounts, loading, userInfo, subaccounts } = useSelector(state => state.appData);

    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
    const month = `${now.getMonth() + 1}`;
    const year = `${now.getFullYear()}`;

    const history = useHistory();
    const d = {
        StartDate: today,
        EndDate: today,
        Account: accounts[0],
        // LocationID: [],
        subAccountId:  []
    };

    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);
    const [locations, setLocations] = useState([]);
    const [subAccountsLocal, setSubAccountsLocal] = useState([]);

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    const [detail, setDetail] = useState({});
    
    const searchObjInit = {
        PaymentID: '',
        RRAmount: '',
        InstrumentNumber: '',
        PaidOn: '',
        InvoiceAmount: ''
    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'PaymentID', name: 'Payment ID', searchBox: true, visible: true},
        {key: 'PaidOn', name: 'Paid On', searchBox: true, visible: true},
        {key: 'RRAmount', name: 'RR Amount', searchBox: true, visible: true},
        {key: 'InvoiceAmount', name: 'Invoice Amount', searchBox: true, visible: true},
        {key: 'IBFTFee', name: 'IBFT Fee', searchBox: false, visible: true},
        {key: 'TaxAmount', name: 'Tax Amount', searchBox: false, visible: true},
        {key: 'NetPayable', name: 'Net Payable', searchBox: false, visible: true},
        {key: 'InstrumentMode', name: 'Instrument Mode', searchBox: false, visible: true},
        {key: 'InstrumentNumber', name: 'Instrument Number', searchBox: true, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (!valdiatePage('/paymentinstrument')) {
            history.push('/login');
        }
    }, []); 

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSearch = async () => {
        if (!data.StartDate) {
            alert('Select Start Date');
            return;
        }
        if (!data.EndDate) {
            alert('Select End Date');
            return;
        }

        if (!data.Account || data.Account.length == 0) {
            alert('Select Account');
            return;
        }

        dispatch(setLoading({ data: true }));

        var rs = await paymentinstrumentreport(data);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
                setDetail(rs.details);
            }
            else {
                alert('No Data Found');
                setGrid([]);
                setOriginalGrid([]);
            }
        }
        else {
            alert(rs.msg);
            setGrid([]);
            setOriginalGrid([]);
        }
    }

    const opendetail = async (paymentid) => {
        sessionStorage.setItem('paymentInstrumentDetail', JSON.stringify(paymentid))
        window.open('/cplight/paymentinstrumentdetail', '_blank');
    }

    useEffect(async () => {
        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())
            setSubAccountsLocal(subAccs);
            const d = { ...data, Account: accounts[0], subAccountId: [subAccs[0].id]};
            setData(d);
        }
    }, [])

    return userInfo &&
        <section className="section">
            <div className="section-header">
                <h1>Payment Instrument Report</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div className="row pb-2">
                    <div className="col-lg-4 col-xl-4">
                        <label>Account</label>
                        <select className="form-select"  value={data.Account} onChange={async (e) => {
                            const value = e.target.value;
                            let d = { ...data, Account: value };
                            if (value && value.length > 0) {
                                const subAccs = subaccounts.filter(e => value.includes(e.accountNo));
                                setSubAccountsLocal(subAccs);
                                d.subAccountId =  [subAccs[0].id];
                            } 
                            setData(d);
                        }}>
                        <option value="">Select Account</option>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>

                    <div className="col-lg-4 col-xl-4">
                        <label>Sub Account</label>
                        <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                            const selectedOptions = Array.from(e.target.selectedOptions);

                            const accnos = selectedOptions
                                .map(option => option.getAttribute('data-accno'))
                                .filter(acc => acc && acc.trim() !== '');
                    

                            const val = Array.from(new Set(
                                selectedOptions
                                    .map(option => option.value)
                                    .filter(v => v && !isNaN(v))
                                    .map(v => parseInt(v))
                            ));


                            const d = { ...data, subAccountId: val };
                            setData({ ...d});
                        }}>
                            {
                                subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                            }
                        </select>
                    </div>


                    <div className="col-lg-4 col-xl-4">
                    <div className="row pb-2 ">
                      <div className="col">
                        <label>Start Date</label>
                        <input type="date" className="form-control" value={data.StartDate} onChange={(e) => updateData('StartDate', e.target.value)} />
                      </div>
                      <div className="col">
                        <label>End Date</label>
                        <input type="date" className="form-control" value={data.EndDate} onChange={(e) => updateData('EndDate', e.target.value)} />
                      </div>
                    </div>
                    </div>
                </div>

                <div className="row">
                    
                    <div className="col">
                        <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem', display : 'flex', placeSelf: 'self-end' }}  onClick={onSearch}>
                            {loading ? <img src={Loader} height="30" /> : 'Search'}
                        </button>
                    </div>
                </div>
                {
                    originalGrid && originalGrid.length > 0 &&
                    <div className="row mt-3 pb-2">
                        <div className="col-12">
                            <div className='table-responsive'>
                                <table width="100%">
                                    <tbody style={{ color: "#8c8c8e" }}><tr>
                                        <td colSpan="1"><b>Account Number</b></td>
                                        <td colSpan="1">{detail.accountNo}</td>
                                        <td colSpan="1"><b>Account Name</b></td>
                                        <td colSpan="1">{detail.AccName}</td>
                                        <td colSpan="1"><b>Credit Client ID</b></td>
                                        <td colSpan="">{detail.creditClientId}</td>
                                    </tr>
                                        <tr>
                                            <td colSpan="1"><b>Beneficiary Name</b></td>
                                            <td colSpan="1">{detail.BeneficiaryName}</td>
                                            <td colSpan="1"><b>Beneficiary Bank Acc#</b></td>
                                            <td colSpan="1">{detail.BeneficiaryBankAccNo}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Bank Name</b></td>
                                            <td colSpan="1">{detail.BANK_NAME}</td>
                                            <td colSpan="1"><b>SBP Code</b></td>
                                            <td colSpan="1">{detail.SBPCode}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Zone Name</b></td>
                                            <td colSpan="1">{detail.ZoneName}</td>
                                            <td colSpan="1"><b>Branch Name</b></td>
                                            <td colSpan="1">{detail.BranchName}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* <br /> */}
                            <div style={{ textAlign: 'right' }}>
                                {/* <ExportExcelIBFT data={originalGrid} /> */}
                                   <ExportExcelButton data={originalGrid} columns={ibftColumns} fileName="IBFTReport"
                                />
                            </div>
                            <br />

                            <Pagination
                                setGrid={setGrid}
                                searchObjInit={searchObjInit}
                                searchObject={searchObject}
                                originalGrid={originalGrid}
                                setPage={setPage}
                                setPageLimit={setPageLimit}
                                requestSort={requestSort}
                                sortConfig={sortConfig}
                                updateSearchData={updateSearchData}
                                sortedArray={sortedArray}
                                data={data}
                                dataCount={grid.length}
                                pageLimit={pageLimit}  
                                gridKeys={gridKeys}
                                page={page}
                                grid={
                                    <>
                                        {sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                            <Fragment key={index}>
                                                <tr key={index}>
                                                    <td>{(index + 1)+(page*pageLimit)}</td>
                                                    <td><a style={{ cursor: 'pointer', color: '#e25a0c', textDecoration: 'underline' }} onClick={(e) => { e.preventDefault(); opendetail(x.PaymentID) }}>{x.PaymentID}</a></td>
                                                    <td style={{whiteSpace: 'nowrap'}}>{x.PaidOn}</td>
                                                    <td>{x.RRAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.InvoiceAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.IBFTFee.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{(x.TaxAmount).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{(x.NetPayable - x.IBFTFee).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.InstrumentMode}</td>
                                                    <td>{x.InstrumentNumber}</td>
                                                </tr>
                                            </Fragment>
                                        )}
                                        <tr>
                                                <td></td>
                                                <td><b>Grand Total: </b></td>
                                                <td></td>
                                                <td><b>{originalGrid.reduce((acc, current) => acc + current.RRAmount, 0).toLocaleString('ur-PK', {
                                                                                style: 'currency',
                                                                                currency: 'PKR',
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                                })}</b></td>
                                                <td><b>{originalGrid.reduce((acc, current) => acc + current.InvoiceAmount, 0).toLocaleString('ur-PK', {
                                                                                style: 'currency',
                                                                                currency: 'PKR',
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                                })}</b></td>
                                                <td><b>{originalGrid.reduce((acc, current) => acc + current.IBFTFee, 0).toLocaleString('ur-PK', {
                                                                                style: 'currency',
                                                                                currency: 'PKR',
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                                })}</b></td>
                                                <td><b>{originalGrid.reduce((acc, current) => acc + current.TaxAmount, 0).toLocaleString('ur-PK', {
                                                                                style: 'currency',
                                                                                currency: 'PKR',
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                                })}</b></td>
                                                <td><b>{(originalGrid.reduce((acc, current) => acc + current.NetPayable, 0) - originalGrid.reduce((acc, current) => acc + current.IBFTFee, 0)).toLocaleString('ur-PK', {
                                                                                style: 'currency',
                                                                                currency: 'PKR',
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                                })}</b></td>
                                            </tr>

                                    </>
                                }
                            />
                        </div>
                    </div>
                }
            </div>
        </section>
}

export default PaymentInstrumentReport;